import { trpc } from "@/lib/trpc";

export const useEmbeddingProvidersQuery = (enabled: boolean = true) => {
    return trpc.embeddingProviders.findAll.useQuery(undefined, { enabled });
};

export const useEmbeddingProviderByIdQuery = (id: string, enabled: boolean = true) => {
    return trpc.embeddingProviders.findById.useQuery({ id }, { enabled: !!id && enabled });
};

export const useEmbeddingProviderQuery = (provider: string, enabled: boolean = true) => {
    return trpc.embeddingProviders.findByProvider.useQuery({ provider }, { enabled: !!provider && enabled });
};

export const useEnabledEmbeddingProviderQuery = (enabled: boolean = true) => {
    return trpc.embeddingProviders.findEnabled.useQuery(undefined, { enabled });
};
